import { Component, ElementRef, ViewChild } from '@angular/core';

import { HelpModalComponent } from './help-modal.component';

/**
 *
 * Help Modal Component Wrapped with Trigger
 *
 */

@Component({
    standalone: false,
    selector: 'ycn-help-modal-with-trigger',
    templateUrl: './help-modal-with-trigger.template.html',
})
export class HelpModalWithTriggerComponent {
    modalName: string;

    triggerLabel: string;

    @ViewChild('helpModal') private helpModal!: HelpModalComponent;

    constructor(private eltRef: ElementRef) {
        this.modalName = this.eltRef.nativeElement.getAttribute('modalName');
        this.triggerLabel = this.eltRef.nativeElement.getAttribute('triggerLabel');
    }

    open(): void {
        this.helpModal.openModal(this.modalName);
    }
}
